module.exports = __webpack_public_path__ + "img/add-chat-bg-fill.a83d525f.svg";